import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    messageContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    message: {
      textAlign: "center",
      textShadow: "0px 1px white",
      marginTop: "1rem",
    },
  }),
);

interface Props {
  message: string;
}

const Spinner: React.FC<Props> = ({ message }) => {
  const localClasses = useStyles();

  return (
    <div className={localClasses.messageContainer}>
      <CircularProgress color="primary" />
      {message && <Typography className={localClasses.message}>{message}</Typography>}
    </div>
  );
};

export default Spinner;
